import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { theme } from '../../themes/theme'
import { SpaceBetweenRowContainer, FlexRow } from '../styles/Containers'
import { BoldMedBodyText } from '../styles/Text'
import { SecondaryButton } from '../common/Button'

export const fileBulkActionsBarStrings = {
  selected: count => `${count} selected`
}

const Bar = styled(SpaceBetweenRowContainer)`
  background: ${theme.colors.primaryExtraLight};
  border-radius: ${theme.borderRadius.div};
  padding: 10px 20px;
`

const Actions = styled(FlexRow)`
  gap: 15px;
  align-items: center;
`

function FileBulkActionsBar({ count, actions = [], className }) {
  if (count === 0) return null

  return (
    <Bar className={className}>
      <BoldMedBodyText>{fileBulkActionsBarStrings.selected(count)}</BoldMedBodyText>
      <Actions>
        {actions.map(action => (
          <SecondaryButton key={action.label} onClick={action.onClick} disabled={action.disabled}>
            {action.icon}
            {action.label}
          </SecondaryButton>
        ))}
      </Actions>
    </Bar>
  )
}

// The bar as the tables mount it, spaced off the table header.
export const SelectionBar = styled(FileBulkActionsBar)`
  margin-bottom: 15px;
`

FileBulkActionsBar.propTypes = {
  count: PropTypes.number.isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      onClick: PropTypes.func.isRequired,
      disabled: PropTypes.bool
    })
  ),
  className: PropTypes.string
}

export default FileBulkActionsBar
